import { useToast } from '@chakra-ui/react'
import dayjs from 'dayjs'
import { FormEvent, useState } from 'react'
import writeXlsxFile, { Row, SheetData } from 'write-excel-file'
import { get } from '../../../lib/http'
import extractDataForm from '../../../utilities/extractDataForm'

import { DataForm, ReportOrderCancellationDetails } from './types'

export default function usePrintOrderCancellationDetails() {
    const toast = useToast()
    const [isLoading, setIsLoading] = useState(false)

    const head: (...values: string[]) => Row[number][] = (...values) =>
        values.map<Row[number]>(val => ({
            value: val,
            fontWeight: 'bold',
            wrap: true,
            alignVertical: 'center',
            align: 'left',
            fontSize: 11
        }))

    function setOrderCancellationDetails(
        data: ReportOrderCancellationDetails[],
        rows: SheetData
    ) {
        data.forEach(item => {
            rows.push([
                {
                    value: item.date,
                    type: String
                },
                {
                    value: item.product,
                    type: String
                },
                {
                    value: item.price,
                    type: Number,
                    align: 'right',
                    format: '#,##0.00'
                },
                {
                    value: item.quantity,
                    type: Number
                },
                {
                    value: item.cancellation_type,
                    type: String
                },
                {
                    value: item.reason,
                    type: String
                },
                {
                    value: item.user_firstname,
                    type: String
                }
            ])
        })
    }

    async function submit(ev: FormEvent<HTMLFormElement>) {
        ev.preventDefault()
        const form = extractDataForm<DataForm>(ev.target)
        const startDate = dayjs
            .tz(form.startDate + ' 00:00:00', 'America/Lima')
            .toISOString()
        const endDate = dayjs
            .tz(form.endDate + ' 23:59:59', 'America/Lima')
            .toISOString()

        const rows: SheetData = [
            [],
            [
                {
                    value: 'Reporte de Anulaciones de Pedidos',
                    fontWeight: 'bold',
                    span: 7,
                    alignVertical: 'center',
                    align: 'center',
                    fontSize: 16
                }
            ],
            [
                {
                    value: `De: ${dayjs(startDate).format(
                        'DD/MM/YYYY'
                    )} - Hasta ${dayjs(endDate).format('DD/MM/YYYY')}`,
                    span: 7,
                    align: 'center'
                }
            ],
            [],
            head(
                ...[
                    'Fecha y Hora',
                    'Producto',
                    'Precio (S/)',
                    'Cantidad',
                    'Tipo de Anulación',
                    'Motivo',
                    'Usuario que anula'
                ]
            )
        ]

        setIsLoading(true)

        const { data, error } = await get<ReportOrderCancellationDetails[]>(
            `/api/reports/order_cancellation_details?start_date=${startDate}&end_date=${endDate}`
        )

        if (error) {
            toast({
                title: 'Hubo un error al cargar los datos',
                status: 'error',
                position: 'top'
            })
            return
        }

        setOrderCancellationDetails(data.result, rows)

        await writeXlsxFile(rows, {
            fileName: `Reporte_de_anulaciones_de_pedidos_${dayjs(
                startDate
            ).format('DD/MM/YYYY')}_${dayjs(endDate).format(
                'DD/MM/YYYY'
            )}.xlsx`,
            columns: [25, 25, 15, 15, 20, 30, 20].map(width => ({
                width
            })),
            fontSize: 10,
            fontFamily: 'Calibri'
        })

        setIsLoading(false)
    }

    return {
        submit,
        isLoading
    }
}
